var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 7",
    filter: "url(#filter0_b_19_810)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 32.1,
    fill: "#444444",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0016 11.3081C12.9584 11.3081 11.3104 12.9564 11.3104 15C11.3104 17.0436 12.9584 18.692 15.0016 18.692C17.0447 18.692 18.6927 17.0436 18.6927 15C18.6927 12.9564 17.0447 11.3081 15.0016 11.3081ZM15.0016 17.4003C13.6813 17.4003 12.6019 16.3239 12.6019 15C12.6019 13.6762 13.678 12.5998 15.0016 12.5998C16.3251 12.5998 17.4013 13.6762 17.4013 15C17.4013 16.3239 16.3219 17.4003 15.0016 17.4003ZM19.7047 11.157C19.7047 11.6358 19.3192 12.0182 18.8437 12.0182C18.3651 12.0182 17.9828 11.6326 17.9828 11.157C17.9828 10.6815 18.3683 10.2959 18.8437 10.2959C19.3192 10.2959 19.7047 10.6815 19.7047 11.157ZM22.1494 12.031C22.0948 10.8775 21.8314 9.8557 20.9865 9.01384C20.1448 8.17198 19.1232 7.90849 17.9699 7.85066C16.7813 7.78318 13.2187 7.78318 12.03 7.85066C10.88 7.90528 9.85839 8.16876 9.01351 9.01063C8.16862 9.85249 7.90841 10.8743 7.85058 12.0278C7.78312 13.2167 7.78312 16.7802 7.85058 17.9691C7.9052 19.1226 8.16862 20.1444 9.01351 20.9863C9.85839 21.8281 10.8768 22.0916 12.03 22.1494C13.2187 22.2169 16.7813 22.2169 17.9699 22.1494C19.1232 22.0948 20.1448 21.8313 20.9865 20.9863C21.8281 20.1444 22.0916 19.1226 22.1494 17.9691C22.2169 16.7802 22.2169 13.2199 22.1494 12.031ZM20.6138 19.2447C20.3632 19.8745 19.8782 20.3597 19.2453 20.6135C18.2976 20.9895 16.0489 20.9027 15.0016 20.9027C13.9543 20.9027 11.7024 20.9863 10.7579 20.6135C10.1282 20.3629 9.64316 19.8777 9.38937 19.2447C9.01351 18.2968 9.10024 16.0476 9.10024 15C9.10024 13.9525 9.01672 11.7001 9.38937 10.7554C9.63994 10.1256 10.125 9.64041 10.7579 9.38657C11.7056 9.01063 13.9543 9.09738 15.0016 9.09738C16.0489 9.09738 18.3008 9.01384 19.2453 9.38657C19.8749 9.6372 20.36 10.1224 20.6138 10.7554C20.9897 11.7033 20.9029 13.9525 20.9029 15C20.9029 16.0476 20.9897 18.3 20.6138 19.2447Z",
    fill: "#F2F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_19_810",
    x: -1.2,
    y: -1.2,
    width: 34.8,
    height: 34.5001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19_810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19_810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagram logo.49e0a4eea482e868b9318709c585c1cc.svg";
export { ForwardRef as ReactComponent };